import React, { useEffect, useState } from "react";
import _ from "lodash";
import { EnvironmentRetrieve } from "Jarvis/JarvisSystems/Pub/Services/EnvironmentService";

/** One colour per environment, so a glance tells them apart. LIVE has no ribbon. */
const RIBBONS = {
  DEV: { label: "DEV", background: "#2e7d32" },
  UAT: { label: "UAT", background: "#e65100" },
  DEMO: { label: "DEMO", background: "#6a1b9a" },
};

const style = (background) => ({
  position: "fixed",
  top: 22,
  left: -40,
  width: 150,
  transform: "rotate(-45deg)",
  zIndex: 2000,
  // Clicks go through to whatever is underneath.
  pointerEvents: "none",
  background,
  color: "#fff",
  textAlign: "center",
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 2,
  lineHeight: "22px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
  opacity: 0.9,
});

/**
 * A corner ribbon naming the environment the server runs as (Environment in the Launcher's
 * Jarvis.Base.Settings.json), so a test site is never mistaken for the real one. Shown for DEV, UAT and DEMO;
 * nothing for LIVE, or when the server cannot be asked.
 */
export default function EnvironmentRibbon() {
  const [environment, setEnvironment] = useState(null);

  useEffect(() => {
    let isMounted = true;
    EnvironmentRetrieve()
      .then((response) => {
        if (isMounted && _.get(response, "ErrorHandling.IsSuccessful"))
          setEnvironment(`${_.get(response, "Data.Environment") ?? ""}`.toUpperCase());
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, []);

  const ribbon = RIBBONS[environment];
  if (!ribbon) return null;
  return (
    <div style={style(ribbon.background)} aria-label={`${ribbon.label} environment`}>
      {ribbon.label}
    </div>
  );
}
